import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@store/constants';

import * as itemQuantityActions from './actions/itemQuantityActions';
import { updateOptionQuantity, resetPersonalOptions } from './actions/optionActions';
import { prepare } from './actions/prepareAction';

export const itemSlice = createSlice({
    name: 'item',
    initialState,
    reducers: {
        prepare,
        ...itemQuantityActions,
        updateOptionQuantity,
        resetPersonalOptions,
    },
});

export const itemActions = itemSlice.actions;

export default itemSlice.reducer;
